import React from "react";

function Rosters() {
  return <h1>Rosters Page</h1>;
}

export default Rosters;
